export interface ISelectable {
  value: string | number | boolean;
  viewValue: string;
}
